import React from 'react';

export function BlobOrange() {
  return (
    <svg
      className="blob-orange pos-a"
      xmlns="http://www.w3.org/2000/svg"
      width={721}
      height={498}
      viewBox="0 0 721 498"
      fill="none"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.454 757.487C25.5096 666.982 -17.6308 518.717 6.54324 382.261C29.1637 254.574 136.68 169.719 246.732 101.131C356.099 32.9689 478.86 -24.4442 602.871 10.6056C735.296 48.0335 847.238 149.979 886.363 281.912C923.668 407.706 868.879 538.293 790.581 643.579C720.453 737.878 612.916 785.348 497.11 805.331C369.323 827.381 228.655 842.177 130.454 757.487Z"
        fill="url(#paint0_radial_orange)"
        fillOpacity={0.4}
      />
      <defs>
        <radialGradient
          id="paint0_radial_orange"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(491.507 507.531) rotate(-55.1543) scale(492.115 492.115)"
        >
          <stop stopColor="#FFCA9E" />
          <stop offset={0.673404} stopColor="#FFF7F0" />
          <stop offset={1} stopColor="#F0FDFF" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
}
